import { Navigate, Route, Routes } from 'react-router-dom';
import Loading from '../components/Loading';
import { SidebarLayout } from '../layouts/SidebarLayout';
import BillingPage from '../pages/billing/BillingPage';
import { useUser } from '../providers/UserProvider';
import { hasBetaFeature } from '../utils/betaFeatures';

const BILLING_BETA_FEATURE = 'billing';

export const BillingRoutes = () => {
    const { user, isLoading, isAuthenticated } = useUser();

    if (isLoading) {
        return <Loading />;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    // Deep-link protection: don't let a bookmarked/shared /billing URL land
    // on the page for a practice that doesn't have the flag yet — same gate
    // as the sidebar item, just redirecting instead of hiding.
    if (!hasBetaFeature(user, BILLING_BETA_FEATURE)) {
        return <Navigate to="/home" replace />;
    }

    return (
        <Routes>
            <Route
                path="/"
                element={
                    <SidebarLayout noScroll>
                        <BillingPage />
                    </SidebarLayout>
                }
            />
        </Routes>
    );
};
